

const Wrapper = ({ classnames, style, children }) => {
  return (
    <div className={`${classnames}`} style={style}>
      {children}
    </div>
  );
};

export default Wrapper;
